// Medications Constants

export const API_URL = process.env.REACT_APP_BACKEND_URL;

export const ROUTES = {
  oral: 'Oral',
  iv: 'Intravenoso',
  im: 'Intramuscular',
  subcutaneous: 'Subcutáneo',
  topical: 'Tópico',
  inhalation: 'Inhalación',
  rectal: 'Rectal',
  sublingual: 'Sublingual',
  transdermal: 'Transdérmico',
  ophthalmic: 'Oftálmico',
  otic: 'Ótico',
  nasal: 'Nasal'
};

export const FREQUENCIES = {
  once: 'Una vez',
  bid: 'Cada 12 horas',
  tid: 'Cada 8 horas',
  qid: 'Cada 6 horas',
  q4h: 'Cada 4 horas',
  q6h: 'Cada 6 horas',
  q8h: 'Cada 8 horas',
  q12h: 'Cada 12 horas',
  daily: 'Diario',
  weekly: 'Semanal',
  prn: 'Según necesidad',
  other: 'Otro'
};

export const STATUS_COLORS = {
  scheduled: 'bg-blue-100 text-blue-800',
  administered: 'bg-green-100 text-green-800',
  missed: 'bg-red-100 text-red-800',
  delayed: 'bg-yellow-100 text-yellow-800',
  refused: 'bg-orange-100 text-orange-800',
  held: 'bg-gray-100 text-gray-800'
};

export const STATUS_LABELS = {
  scheduled: 'Programado',
  administered: 'Administrado',
  missed: 'Omitido',
  delayed: 'Retrasado',
  refused: 'Rechazado',
  held: 'Suspendido'
};
